import config from '../_config/config.const';

export function isEmbeddedInIframe(): boolean {
    try {
        return window.self !== window.top;
    } catch {
        return true;
    }
}

// Get list of allowed target origins
const TARGET_ORIGINS: string[] = Array.isArray((config as any).ORIGINS) && (config as any).ORIGINS.length
    ? (config as any).ORIGINS
    : (config as any).ORIGIN
        ? [(config as any).ORIGIN]
        : [];

// Helper to post a message to all allowed parent origins
const postToAllowedParents = (message: unknown) => {
    if (!isEmbeddedInIframe()) return;

    if (!TARGET_ORIGINS.length) {
        window.parent.postMessage(message, '*');
        return;
    }

    TARGET_ORIGINS.forEach(origin => {
        try {
            window.parent.postMessage(message, origin);
        } catch (err) {
            console.warn(`[postMessage] failed for origin "${origin}":`, err);
        }
    });
};

export const sendHeightToParent = () => {
    const height = document.body.scrollHeight;

    postToAllowedParents({
        type: 'RESIZE',
        height,
    });
};

export const sendBodyHeightToParent = () => {
    const height = document.body.scrollHeight + 50;

    postToAllowedParents({
        type: 'RESIZE',
        height,
    });
};



export const sendContainerHeightToParent = () => {
    const container = document.getElementById('formContainer');
    if (!container) return;

    const height = container.scrollHeight + 100;

    postToAllowedParents({
        type: 'RESIZE',
        height,
    });
};

export const sendContainerHeightToParent2 = () => {
    const container = document.getElementById("formContainer");
    const bodyHeight = document.body.scrollHeight;

    const containerHeight = container ? container.scrollHeight : 0;

    const baseHeight = Math.max(bodyHeight, containerHeight);
    const height = baseHeight + 50;

    console.log("[IFRAME] sendContainerHeightToParent", {
        bodyHeight,
        containerHeight,
        finalHeight: height,
        path: window.location.pathname,
    });

    postToAllowedParents({
        type: "RESIZE",
        height,
    });
};


export const sendScrollMessageToParent = () => {
    postToAllowedParents({
        type: 'SCROLL_TOP',
    });
};

export function retryHeight(sendHeightFn: () => void, maxAttempts = 10, delay = 300) {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    let attempts = 0;

    const trySendingHeight = () => {
        if (attempts >= maxAttempts) return;
        attempts++;

        requestAnimationFrame(() => {
            setTimeout(() => {
                sendHeightFn();
                if (attempts < maxAttempts) {
                    // console.log(`[Retry] Sending body height (attempt ${attempts + 1})`);
                    trySendingHeight();
                }
            }, delay);
        });
    };

    trySendingHeight();
}
